module.exports = __webpack_public_path__ + "images/2cbdd544369b71881482977fb78be468.png";